import "./App.css";
import Navbar from "./components/Navbar";
import Audios from "./components/Audio";
function App() {
  return (
    <div className="App">
      <Navbar />
      <Audios />
    </div>
  );
}

export default App;
